import './App.css';
import Navbar from './Components/Navbar/Navbar';
import {BrowserRouter , Routes, Route} from 'react-router-dom';
import Shop from './Pages/Shop';
import ShopCategory from './Pages/ShopCategory';
import Product from './Pages/Product';
import Cart from './Pages/Cart';
import LoginSignup from './Pages/LoginSignup';
import Footer from './Components/Footer/Footer';
import men_banner from './Components/Assets/banner_mens.png'
import Women_banner from './Components/Assets/banner_women.png'
import kid_banner from './Components/Assets/banner_kids.png'
import NewCollections from './Components/NewCollections/NewCollections';
import NotFound from './Components/NotFound/NotFound';

function App() {
  return (
    <div>
      <BrowserRouter basename='/ecommerce-react'>
        <Navbar />
        <Routes>
          <Route path='/' element={<Shop />}/> 
          <Route path='/mens' element={<ShopCategory banner={men_banner} category='men' />} /> 
          <Route path='/womens' element={<ShopCategory banner={Women_banner} category='women' />} /> 
          <Route path='/kids' element={<ShopCategory banner={kid_banner} category='kid' />} /> 
          <Route path='/product' element={<Product />}>
            <Route path=':productId' element={<Product />}/>
          </Route>
          <Route path='/cart' element={<Cart />} /> 
          <Route path='/login' element={<LoginSignup />} /> 
          <Route path='/new' element={<NewCollections />} /> 
          <Route path='/*' element={<NotFound />} /> 
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
